import { render, staticRenderFns } from "./SideBarFooter.vue?vue&type=template&id=7af50eee&scoped=true&"
import script from "./SideBarFooter.vue?vue&type=script&lang=js&"
export * from "./SideBarFooter.vue?vue&type=script&lang=js&"
import style0 from "./SideBarFooter.vue?vue&type=style&index=0&id=7af50eee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af50eee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VList,VProgressLinear,VSpacer})
